import React from "react";
import { styled } from "@mui/material/styles";
import Info from "@mui/icons-material/Info";

import PageSidebar from "../pageSidebar/PageSidebar";

// Styled components
const PageWithHeaderAndSidebar = styled("div")({
  width: "100%",
  height: "calc(100% - 60px)",
  display: "flex",
});

const PageWithHeader = styled("div")({
  width: "100%",
  height: "calc(100% - 60px)",
});

const PageWithSidebar = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",
});

const Page = styled("div")({
  width: "100%",
  height: "100%",
});

const PageContent = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: 40,
  backgroundColor: "#f8f8f8",
  overflowY: "auto",
  [theme.breakpoints.down("sm")]: {
    padding: 20,
  },
}));

const Title = styled("div")({
  color: "#000000",
  fontSize: "18px",
  lineHeight: "21px",
  marginBottom: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

const InfoClick = styled("div")({
  marginLeft: 5,
  cursor: "pointer",
});

// Component
function PageWrapper({
  children,
  showHeader,
  showSidebar,
  title,
  showMinimizedSidebar,
  showOnInfoClick,
  onInfoClick,
  actionButtons,
  rightContent,
}) {
  const renderContent = () => (
    <Page>
      {title && (
        <Title>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {title}
            {showOnInfoClick && (
              <InfoClick onClick={onInfoClick}>
                <Info />
              </InfoClick>
            )}
            {actionButtons}
          </div>
          {rightContent}
        </Title>
      )}
      {children}
    </Page>
  );

  if (showHeader && showSidebar) {
    return (
      <PageWithHeaderAndSidebar>
        <PageSidebar showMinimizedSidebar={showMinimizedSidebar} />
        <PageContent>{renderContent()}</PageContent>
      </PageWithHeaderAndSidebar>
    );
  } else if (showHeader) {
    return (
      <PageWithHeader>
        <PageContent>{renderContent()}</PageContent>
      </PageWithHeader>
    );
  } else if (showSidebar) {
    return (
      <PageWithSidebar>
        <PageSidebar showMinimizedSidebar={showMinimizedSidebar} />
        <PageContent>{renderContent()}</PageContent>
      </PageWithSidebar>
    );
  } else {
    return (
      <Page>
        <PageContent>{renderContent()}</PageContent>
      </Page>
    );
  }
}

export default PageWrapper;
